import Layout from '@/shared/components/Layout/Layout'
import { useUsers } from '@/features/users'
import { useRolesQuery } from '@/features/role'
import styles from './DashboardPage.module.scss'
import { MaterialIcon } from '@/ui/material-icon'

export function DashboardPage() {
  const { data } = useUsers(true)
  const { data: rolesData } = useRolesQuery({
    isActive: '1',
    pageNumber: 1,
    limit: 1,
  })

  const rolesCount = rolesData?.total ?? 0

  return (
    <Layout breadcrumbs={['Admin', 'Dashboard']}>
      <div className={styles.dashboard}>
        <div className={styles.dashboardCard}>
          <div className={styles.cardRow}>

            {/* New Users Card */}
            <div className={styles.statCard}>
              <div className={styles.iconWrapper}>
                <MaterialIcon name="group" size={24} className={styles.icon} />
              </div>

              <div className={styles.statValue}>
                {data?.length ?? 0}
              </div>

              <div className={styles.statTitle}>
                New Users
              </div>

              <div className={styles.statDescription}>
                Number of users onboarded
              </div>
            </div>

            {/* Roles Count Card */}
            <div className={styles.statCard}>
              <div className={styles.iconWrapper}>
                <MaterialIcon name="verified" size={24} className={styles.icon} />
              </div>

              <div className={styles.statValue}>
                {rolesCount ?? 0}
              </div>

              <div className={styles.statTitle}>
                Roles
              </div>

              <div className={styles.statDescription}>
                Active roles count
              </div>
            </div>

          </div>
        </div>
      </div>
    </Layout>
  )
}